import { useState } from "react";
import PdfViewerModal from "../Modal/PdfViewerModal";
import "./DocumentItem.scss";
export interface DocumentItemProps {
  name: string | undefined;
  path: string | "";
}

const DocumentItem: React.FunctionComponent<DocumentItemProps> = ({
  name,
  path,
}) => {
  const [isPdfViewerModalOpen, setPdfViewerModalOpen] = useState(false);
  const [pdfData, setPdfData] = useState<any>({});

  const viewDocumentFileHandler = (path: string, name: any) => {
    setPdfData({ name: name, path: path });
    setPdfViewerModalOpen(true);
  };

  const closePdfViewerHandler = () => {
    setPdfViewerModalOpen(false);
  };

  return (
    <>
      <div
        className="document-item-container"
        onClick={() => viewDocumentFileHandler(path, name)}
      >
        <img src="../svgs/doc.svg" alt="doc_icon" className="doc-icon" />
        <p className="doc-name">{name}</p>
      </div>

      <PdfViewerModal
        pdfData={pdfData}
        isPdfOpen={isPdfViewerModalOpen}
        closeModal={closePdfViewerHandler}
      />
    </>
  );
};

export default DocumentItem;
